import styled from 'styled-components';

export const ProgressBarContainer = styled.div`
  padding-right: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2.5)};
`;
